function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsArrowLeft, vsArrowRight, vsSearch } from '@deephaven/icons';
import classNames from 'classnames';
import Button from "./Button.js";
import "./SearchInput.css";
import { GLOBAL_SHORTCUTS } from "./shortcuts/index.js";
import { ContextActions } from "./context-actions/index.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
class SearchInput extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "inputField", void 0);
    _defineProperty(this, "searchChangeSelection", void 0);
    this.inputField = /*#__PURE__*/React.createRef();
    this.searchChangeSelection = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    this.setInputPaddingRight();
  }
  componentDidUpdate() {
    this.setInputPaddingRight();
  }
  focus() {
    var _this$inputField$curr;
    (_this$inputField$curr = this.inputField.current) === null || _this$inputField$curr === void 0 || _this$inputField$curr.focus();
  }
  select() {
    var _this$inputField$curr2;
    (_this$inputField$curr2 = this.inputField.current) === null || _this$inputField$curr2 === void 0 || _this$inputField$curr2.select();
  }
  setInputPaddingRight() {
    var inputField = this.inputField.current;
    var searchChangeSelection = this.searchChangeSelection.current;
    if (inputField && searchChangeSelection) {
      var paddingRight = searchChangeSelection.getBoundingClientRect().width;
      inputField.style.paddingRight = "".concat(paddingRight, "px");
    }
  }
  render() {
    var _this$props = this.props,
      value = _this$props.value,
      placeholder = _this$props.placeholder,
      endPlaceholder = _this$props.endPlaceholder,
      onBlur = _this$props.onBlur,
      onChange = _this$props.onChange,
      className = _this$props.className,
      disabled = _this$props.disabled,
      matchCount = _this$props.matchCount,
      id = _this$props.id,
      onKeyDown = _this$props.onKeyDown,
      dataTestId = _this$props['data-testid'],
      cursor = _this$props.cursor;
    var matchCountSection;
    var contextActions = [{
      action: () => cursor === null || cursor === void 0 ? void 0 : cursor.next('forward'),
      shortcut: GLOBAL_SHORTCUTS.NEXT
    }, {
      action: () => cursor === null || cursor === void 0 ? void 0 : cursor.next('back'),
      shortcut: GLOBAL_SHORTCUTS.PREVIOUS
    }];
    if (cursor && matchCount > 1) {
      matchCountSection = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "search-change-button",
          type: "button",
          onClick: () => {
            cursor.next('back');
          },
          icon: vsArrowLeft,
          tooltip: "Previous match (".concat(GLOBAL_SHORTCUTS.PREVIOUS.getDisplayText(), ")")
        }), /*#__PURE__*/_jsxs("span", {
          className: "search-change-text",
          children: [cursor.index !== undefined && "".concat(cursor.index + 1, " of "), matchCount]
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "search-change-button",
          type: "button",
          onClick: () => {
            cursor.next('forward');
          },
          icon: vsArrowRight,
          tooltip: "Next match (".concat(GLOBAL_SHORTCUTS.NEXT.getDisplayText(), ")")
        })]
      });
    } else {
      matchCountSection = matchCount > 0 && /*#__PURE__*/_jsx("span", {
        className: "search-match",
        children: matchCount
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: classNames('search-group', className),
      children: [/*#__PURE__*/_jsx("input", {
        type: "search",
        value: value,
        onBlur: onBlur,
        onChange: onChange,
        onKeyDown: onKeyDown,
        className: "form-control",
        disabled: disabled,
        placeholder: placeholder,
        ref: this.inputField,
        id: id,
        "data-testid": dataTestId
      }), matchCount != null ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "search-change-selection",
          ref: this.searchChangeSelection,
          children: matchCountSection
        }), /*#__PURE__*/_jsx(ContextActions, {
          actions: contextActions
        })]
      }) : /*#__PURE__*/_jsxs("span", {
        className: "search-end-content",
        children: [(endPlaceholder !== null && endPlaceholder !== void 0 ? endPlaceholder : '') !== '' && value === '' && /*#__PURE__*/_jsx("span", {
          className: "search-end-placeholder",
          children: endPlaceholder
        }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsSearch
        })]
      })]
    });
  }
}
_defineProperty(SearchInput, "defaultProps", {
  placeholder: 'Search',
  className: '',
  matchCount: null,
  onKeyDown() {
    // no-op
  },
  id: '',
  'data-testid': undefined,
  cursor: undefined
});
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map